import { render, staticRenderFns } from "./partnerforget.vue?vue&type=template&id=0bb02fed&scoped=true"
import script from "./partnerforget.vue?vue&type=script&lang=js"
export * from "./partnerforget.vue?vue&type=script&lang=js"
import style0 from "./partnerforget.vue?vue&type=style&index=0&id=0bb02fed&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bb02fed",
  null
  
)

export default component.exports